import { useT } from "@/lib/i18n";

const y = (h, d) => 108 - Math.max(0, Math.min(1, h / d)) * 96;

export function TankCutaway({ diameter, startInches, finalInches, h90, h95, fluidColor }) {
  const ys = y(startInches, diameter);
  const yf = y(finalInches, diameter);
  const t = useT();
  return (
    <div className="cutaway" data-testid="tank-cutaway">
      <svg viewBox="0 0 120 120" className="cutaway-svg">
        <defs><clipPath id="tankClip"><circle cx="60" cy="60" r="48" /></clipPath></defs>
        <circle cx="60" cy="60" r="54" fill="#111827" stroke="#1F2937" strokeWidth="2.5" />
        <circle cx="60" cy="60" r="48" fill="#030712" stroke="#374151" strokeWidth="2" />
        <g clipPath="url(#tankClip)">
          <rect x="0" y={yf} width="120" height={120 - yf} fill={fluidColor} opacity="0.35" />
          <rect x="0" y={ys} width="120" height={120 - ys} fill={fluidColor} opacity="0.85" />
          <line x1="0" y1={y(h90, diameter)} x2="120" y2={y(h90, diameter)} stroke="#F59E0B" strokeWidth="1.2" strokeDasharray="2.5 2.5" />
          <line x1="0" y1={y(h95, diameter)} x2="120" y2={y(h95, diameter)} stroke="#F87171" strokeWidth="1.4" strokeDasharray="2 2" />
        </g>
        <line x1="60" y1="8" x2="60" y2="108" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round" />
        <line x1="56" y1={ys} x2="64" y2={ys} stroke="#F3F4F6" strokeWidth="2" />
        <line x1="54" y1={yf} x2="66" y2={yf} stroke="#22D3EE" strokeWidth="2.5" />
        <circle cx="60" cy="60" r="48" fill="none" stroke="#374151" strokeWidth="1.5" />
      </svg>
      <div className="legend">
        <Legend color={fluidColor} label={t("Start level")} />
        <Legend color={fluidColor} faded label={t("Added volume")} />
        <Legend color="#F59E0B" line label={t("90% limit")} />
        <Legend color="#F87171" line label={t("95% shutoff")} />
      </div>
    </div>
  );
}

function Legend({ color, label, faded, line }) {
  return (
    <span className="legend-item">
      <span className={line ? "legend-line" : "legend-dot"} style={{ background: color, opacity: faded ? 0.35 : 1 }} />
      <span className="legend-text">{label}</span>
    </span>
  );
}
